module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.extra.isDirectDeal) ? _c('div', {
    staticClass: "legend"
  }, [_vm._v("退款规则  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：“随时退、有条件退”需要商家在三个工作日内确认，否则系统将默认同意退款，自动确认并退给用户")])]) : _c('div', {
    staticClass: "legend"
  }, [_vm._v("退款规则  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：“随时退、有条件退”需要商家在24小时内确认，否则系统将默认同意退款，自动确认并退给用户")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), (_vm.model.generateTicketMethod == 2 && !_vm.extra.isDirectDeal && !_vm.isTuan) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "col-sm-9"
  }, [(!_vm.extra.isDirectDeal && !_vm.extra.isDirect) ? _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "2"
      }
    }
  }), _vm._v("\n                    极速退\n                ")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre),
      expression: "!model.IAmTheatre"
    }],
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "1"
      }
    }
  }), _vm._v("\n                    随时退\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "annotate"
  }, [_vm._v("未消费订单，无论是否过期，订单可多次退款，随时可退，无退款手续费。")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundType == 1 && _vm.extra.isDirectDeal),
      expression: "model.refundType==1 && extra.isDirectDeal"
    }],
    staticClass: "radio bd pd10"
  }, [_c('div', [_c('refund-limit-time', {
    attrs: {
      "model": _vm.model
    }
  }), _vm._v(" "), (_vm.model.useDateMode == 1) ? _c('div', {
    staticClass: "no-pdl",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', {
    style: ({
      color: _vm.model.canRefundCurrentDate ? '#999' : '#1f2d3d'
    }),
    attrs: {
      "for": "oPCanRefundCurrentDate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.oPCanRefundCurrentDate),
      expression: "model.oPCanRefundCurrentDate"
    }],
    attrs: {
      "id": "oPCanRefundCurrentDate",
      "type": "checkbox",
      "disabled": _vm.model.useDateDays > 2,
      "name": "oPCanRefundCurrentDate"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.model.oPCanRefundCurrentDate) ? _vm._i(_vm.model.oPCanRefundCurrentDate, true) > -1 : (_vm.model.oPCanRefundCurrentDate)
    },
    on: {
      "change": _vm.refundCurrent,
      "__c": function($event) {
        var $$a = _vm.model.oPCanRefundCurrentDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.oPCanRefundCurrentDate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.oPCanRefundCurrentDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.oPCanRefundCurrentDate = $$c
        }
      }
    }
  }), _vm._v("\n                            游玩当日不可申请退款\n                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.useDateDays > 2),
      expression: "model.useDateDays > 2"
    }],
    staticClass: "red",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("有效期设置请小于3天内有效")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "4")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "4"
      }
    }
  }), _vm._v("\n                    有条件退\n                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundType == 4 && !_vm.model.IAmTheatre),
      expression: "model.refundType==4 && !model.IAmTheatre"
    }],
    staticClass: "red",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("若选择极速退、随时退，订单量可增加约15%")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundType == 4),
      expression: "model.refundType==4"
    }],
    staticClass: "radio bd pd10"
  }, [_c('div', [(_vm.model.useDateMode == 1 && _vm.extra.isDirectDeal && !_vm.model.IAmTheatre) ? _c('div', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "id": "stairsRefund"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._l((_vm.model.refundStairsRules), function(stair, index) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_c('v-select', {
      staticClass: "col-sm-3",
      staticStyle: {
        "margin-bottom": "15px",
        "max-width": "180px"
      },
      attrs: {
        "clearable": false,
        "size": "md",
        "placeholder": "请选择"
      },
      model: {
        value: (stair.refundTimeType),
        callback: function($$v) {
          stair.refundTimeType = $$v
        },
        expression: "stair.refundTimeType"
      }
    }, _vm._l((_vm.priceTimeRestrictOpt), function(item) {
      return (!(_vm.model.refundStairsRules.length > 1 && item.value == 0)) ? _c('v-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      }) : _vm._e()
    })), _vm._v(" "), _c('div', {
      staticClass: "inline-block col-sm-9 no-pdl",
      staticStyle: {
        "overflow": "visible"
      }
    }, [(stair.refundTimeType != 0) ? _c('div', {
      staticClass: "pull-left inline-block",
      staticStyle: {
        "margin-left": "4px"
      }
    }, [_c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "step": 1,
        "min": stair.refundTimeType == 3 || stair.refundTimeType == 1 ? 1 : 0,
        "max": 1000,
        "isInt": true
      },
      model: {
        value: (stair.aheadDays),
        callback: function($$v) {
          stair.aheadDays = $$v
        },
        expression: "stair.aheadDays"
      }
    }), _vm._v("\n                                         天\n                                        "), _c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "min": 0,
        "max": 23,
        "isInt": true
      },
      model: {
        value: (stair.hours),
        callback: function($$v) {
          stair.hours = $$v
        },
        expression: "stair.hours"
      }
    }), _vm._v("\n                                         点\n                                        "), _c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "min": 0,
        "max": 59,
        "isInt": true
      },
      model: {
        value: (stair.minutes),
        callback: function($$v) {
          stair.minutes = $$v
        },
        expression: "stair.minutes"
      }
    }), _vm._v("\n                                         分前可退\n                                    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: " form-group",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('div', {
      staticClass: "inline-block col-sm-4 no-pdl"
    }, [_c('v-select', {
      attrs: {
        "clearable": false,
        "size": "md",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeRefundFee(index)
        }
      },
      model: {
        value: (stair.refundFeeMode),
        callback: function($$v) {
          stair.refundFeeMode = $$v
        },
        expression: "stair.refundFeeMode"
      }
    }, _vm._l((_vm.refundFeeModeTypes), function(item) {
      return _c('v-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-block no-pdl",
      staticStyle: {
        "min-width": "70px"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (stair.refundFeeMode != 1),
        expression: "stair.refundFeeMode != 1"
      }],
      staticClass: "inline-block"
    }, [_c('div', {
      staticClass: "pull-left inline-block",
      staticStyle: {
        "margin-left": "4px"
      }
    }, [_c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "min": 0,
        "isInt": stair.refundFeeMode == 4
      },
      on: {
        "change": function($event) {
          _vm.changeRefundFee(index)
        }
      },
      model: {
        value: (stair.refundFeeDump),
        callback: function($$v) {
          stair.refundFeeDump = $$v
        },
        expression: "stair.refundFeeDump"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "inline-block no-pdl"
    }, [(index == 0 && stair.refundTimeType != 0) ? _c('v-button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.addStair()
        }
      }
    }, [_c('i', {
      staticClass: "icon-button icon-plus"
    })]) : (index != 0) ? _c('v-button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.removeStair(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      }
    })]) : _vm._e()], 1)])])], 1)
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab3', 'model.refundStairsRules')),
      expression: "validateErrors.has('tab3', 'model.refundStairsRules')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("退款规则设置不一致")])], 2)]) : _c('div', {
    attrs: {
      "id": "normalRefund"
    }
  }, [_c('div', {
    staticClass: "no-pdl"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("时间限制")]), _vm._v(" "), _c('div', {
    staticClass: "inline-block col-sm-10 form-group"
  }, [_c('div', {
    staticClass: "inline-block col-sm-4"
  }, [(_vm.model.useDateMode == 0) ? _c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundTimeType),
      callback: function($$v) {
        _vm.model.refundTimeType = $$v
      },
      expression: "model.refundTimeType"
    }
  }, _vm._l((_vm.timeRestrictOpt), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.model.useDateMode != 0) ? _c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundTimeType),
      callback: function($$v) {
        _vm.model.refundTimeType = $$v
      },
      expression: "model.refundTimeType"
    }
  }, _vm._l((_vm.priceTimeRestrictOpt), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), (_vm.model.refundTimeType != 0) ? _c('div', {
    staticClass: "inline-block col-sm-8"
  }, [_c('div', {
    staticClass: "pull-left inline-block",
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "step": 1,
      "min": 0,
      "max": 1000,
      "isInt": true
    },
    model: {
      value: (_vm.model.refundLimitDays),
      callback: function($$v) {
        _vm.model.refundLimitDays = $$v
      },
      expression: "model.refundLimitDays"
    }
  }), _vm._v("\n                                         天\n                                        "), _c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "min": 0,
      "max": 23,
      "isInt": true
    },
    model: {
      value: (_vm.model.refundLimitHours),
      callback: function($$v) {
        _vm.model.refundLimitHours = $$v
      },
      expression: "model.refundLimitHours"
    }
  }), _vm._v("\n                                         点\n                                        "), _c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "min": 0,
      "max": 59,
      "isInt": true
    },
    model: {
      value: (_vm.model.refundLimitMinutes),
      callback: function($$v) {
        _vm.model.refundLimitMinutes = $$v
      },
      expression: "model.refundLimitMinutes"
    }
  }), _vm._v("\n                                         分\n                                    ")], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "no-pdl "
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("手续费")]), _vm._v(" "), _c('div', {
    staticClass: "inline-block col-sm-10 form-group"
  }, [_c('div', {
    staticClass: "inline-block col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundFeeMode),
      callback: function($$v) {
        _vm.model.refundFeeMode = $$v
      },
      expression: "model.refundFeeMode"
    }
  }, _vm._l((_vm.refundFeeModeTypes), function(item) {
    return (item.value != 4) ? _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundFeeMode != 1),
      expression: "model.refundFeeMode != 1"
    }],
    staticClass: "inline-block col-sm-8"
  }, [_c('div', {
    staticClass: "pull-left inline-block",
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.model.refundFee),
      callback: function($$v) {
        _vm.model.refundFee = $$v
      },
      expression: "model.refundFee"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.extra.isDirectDeal && !_vm.model.IAmTheatre) ? _c('div', {
    staticClass: "no-pdl",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('refund-limit-time', {
    style: ({
      'padding-left': _vm.model.useDateMode != 1 ? '8%' : '15px'
    }),
    attrs: {
      "model": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.model.useDateMode == 1 && this.hasNoRefund) ? _c('div', {
    staticClass: "no-pdl",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('label', {
    style: ({
      color: _vm.model.canRefundCurrentDate ? '#999' : '#1f2d3d'
    }),
    attrs: {
      "for": "oPCanRefundCurrentDate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.oPCanRefundCurrentDate),
      expression: "model.oPCanRefundCurrentDate"
    }],
    attrs: {
      "id": "oPCanRefundCurrentDate",
      "type": "checkbox",
      "disabled": _vm.model.useDateDays > 2,
      "name": "oPCanRefundCurrentDate"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.model.oPCanRefundCurrentDate) ? _vm._i(_vm.model.oPCanRefundCurrentDate, true) > -1 : (_vm.model.oPCanRefundCurrentDate)
    },
    on: {
      "change": _vm.refundCurrent,
      "__c": function($event) {
        var $$a = _vm.model.oPCanRefundCurrentDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.oPCanRefundCurrentDate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.oPCanRefundCurrentDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.oPCanRefundCurrentDate = $$c
        }
      }
    }
  }), _vm._v("\n                            游玩当日不可申请退款\n                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.useDateDays > 2),
      expression: "model.useDateDays > 2"
    }],
    staticClass: "red",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("有效期设置请小于3天内有效")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "no-pdl"
  }, [_c('label', {
    staticClass: "col-sm-2",
    class: {
      'control-label': !_vm.extra.isDirectDeal || _vm.model.useDateMode != 1
    },
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v("是否部分退款")]), _vm._v(" "), (!_vm.model.IAmTheatre) ? _c('div', {
    staticClass: "radio-inline"
  }, [_c('label', {
    attrs: {
      "for": "BatchRefund"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.partlyRefund),
      expression: "model.partlyRefund"
    }],
    attrs: {
      "id": "BatchRefund",
      "type": "radio",
      "value": "true",
      "name": "partlyRefund"
    },
    domProps: {
      "checked": _vm._q(_vm.model.partlyRefund, "true")
    },
    on: {
      "__c": function($event) {
        _vm.model.partlyRefund = "true"
      }
    }
  }), _vm._v("\n                                可分批退款")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radio-inline"
  }, [_c('label', {
    attrs: {
      "for": "OnceCompletedRefund"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.partlyRefund),
      expression: "model.partlyRefund"
    }],
    attrs: {
      "id": "OnceCompletedRefund",
      "type": "radio",
      "value": "false",
      "name": "partlyRefund"
    },
    domProps: {
      "checked": _vm._q(_vm.model.partlyRefund, "false")
    },
    on: {
      "__c": function($event) {
        _vm.model.partlyRefund = "false"
      }
    }
  }), _vm._v("\n                                不可，只能一次退完")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "3"
      }
    }
  }), _vm._v("\n                    不可退款\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "annotate"
  }, [_vm._v("一经购买，不可退款。不可退可能造成商品曝光或销量的不良影响，请慎重勾选该项。")])])])]), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_vm._v("退款补充说明")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('v-input', {
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 300,
      "placeholder": "选填，如果上述没有包含商家需要说明的退款条件或者流程，可以在这个地方填写。如果直接使用美团平台的退款流程，不需要填写本栏"
    },
    model: {
      value: (_vm.model.refundNote),
      callback: function($$v) {
        _vm.model.refundNote = $$v
      },
      expression: "model.refundNote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.refundNote.length > 300 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.refundNote.length) + "/300字")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("退款设置")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', [_vm._v("\n                    极速退\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "inline-block annotate"
  }, [_vm._v("待出票的订单，用户申请退款，"), _c('span', {
    staticClass: "black"
  }, [_vm._v("不经过商家确认")]), _vm._v("，系统自动立即退款给用户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inline-block annotate"
  }, [_vm._v("未消费订单，无论是否过期，订单可多次退款，"), _c('span', {
    staticClass: "black"
  }, [_vm._v("无需商家确认立即退款")]), _vm._v("，选择本项的商家请验票后再入园，以防损失")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-required",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("退款时间和手续费设置")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699e3f8b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/refund.vue
// module id = 567
// module chunks = 0